import { LegalLayout } from "@/components/shared/LegalLayout";
import { NextSeo } from "next-seo";

export default function TermsConditions() {
  return (
    <>
      <NextSeo
        title="Crayo AI | Terms of Service"
        description="Terms of Service for Crayo AI - Your gateway to creating viral TikTok clips in seconds!"
      />
      <LegalLayout content={content} eyebrow="Terms of Service" lastUpdated="March 21st, 2024" />
    </>
  );
}

const content = {
  title: "Terms of Service",
  description:
    "Terms of Service for Crayo AI - Your gateway to creating viral TikTok clips in seconds!",
  effectiveDate: "March 21st, 2024",
  sections: [
    {
      title: "Acceptance of Terms",
      content:
        'By accessing and using the services provided by Crayo AI, you agree to be bound by these Terms of Service ("TOS"). If you do not agree to these terms, please do not use our services.',
    },
    {
      title: "Description of Service",
      content:
        "Crayo AI provides AI-powered editing tools designed to assist users in creating and editing content. Our services are subject to the terms and conditions outlined in this TOS.",
    },
    {
      title: "Use of Service",
      content: [
        "You agree to use Crayo AI's services only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the service.",
        "Crayo AI grants you a non-exclusive, non-transferable, limited right to access and use the services for your personal, non-commercial purposes, subject to these TOS.",
      ],
    },
    {
      title: "User Conduct",
      content: [
        "You are solely responsible for any content you create, transmit, or display while using Crayo AI's services and for the consequences of your actions.",
        "You agree not to upload, communicate, transmit, or otherwise make available any content that is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.",
      ],
    },
    {
      title: "Intellectual Property",
      content: [
        "You retain all ownership rights to the content you create or upload. However, by using Crayo AI's services, you grant Crayo AI a worldwide, non-exclusive, royalty-free license to use, reproduce, distribute, and display the content in connection with the service.",
        "Crayo AI owns all rights to the software, applications, and intellectual property related to the service.",
      ],
    },
    {
      title: "Termination",
      content:
        "Crayo AI reserves the right to terminate your access to the services without notice for any breach of these TOS.",
    },
    {
      title: "Refund Policy",
      content: `Crayo does not offer refunds in accordance to the full refund policy listed on <Link className="text-blue-600 hover:underline" href="https://crayo.ai/refund-policy">crayo.ai/refund-policy</Link>`,
    },
    {
      title: "Disclaimer of Warranties",
      content:
        'The services are provided "as is" and "as available" without warranty of any kind, either express or implied. Crayo AI does not guarantee that the service will meet your requirements or be available on an uninterrupted, secure, or error-free basis.',
    },
    {
      title: "Age Restriction",
      content:
        "Crayo AI's services are not intended for use by individuals under the age of 18. By using our services, you represent and warrant that you are at least 18 years of age. If we become aware that a user is under 18, we reserve the right to terminate their account and access to our services immediately.",
    },
    {
      title: "Limitation of Liability",
      content:
        "Crayo AI shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages resulting from your use of the services.",
    },
    {
      title: "Changes to Terms",
      content:
        "Crayo AI reserves the right to modify these TOS at any time. Your continued use of the service after such changes constitutes your acceptance of the new TOS.",
    },
    {
      title: "Governing Law",
      content:
        "These TOS and your use of the services are governed by the laws of the jurisdiction where Crayo AI is established, without regard to its conflict of law provisions.",
    },
    {
      title: "Contact Information",
      content: "For any questions regarding these TOS, please contact us at support@crayo.ai.",
    },
  ],
};
